import { render, staticRenderFns } from "./IconSvgGrid.vue?vue&type=template&id=1988b651&scoped=true&"
import script from "./IconSvgGrid.vue?vue&type=script&lang=js&"
export * from "./IconSvgGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988b651",
  null
  
)

export default component.exports